// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"cf963df0","540":"71685ece","586":"ed61e507","688":"88ac7e65","978":"cf963df0","989":"00955435"}[chunkId] + ".chunk.css";
};